import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';

import { localization } from 'src/App/shared/localization/localization';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';

export interface IEditorErrorDialogProps {
    title: string;
    msgContent: string;
    errorMessage?: string;
    closeBtnText?: string;
    onClose(): void;
}

export const EditorErrorDialog = (props: IEditorErrorDialogProps) => {
    return (
        <div className="small-popup-dialog-root editor-error-dialog-root">
            <div className="title primary-style">
                <h3><Markdown text={props.title} /></h3>
                <div className="dialog-close-container">
                    <button onClick={() => props.onClose()}>
                        <FontAwesomeIcon icon={faTimes} color={'black'} />
                    </button>
                </div>
            </div>
            <div className="content-container">
                <div className="content">
                    <div className="info-fail">
                        <div className="icon">
                            <FontAwesomeIcon icon={faExclamationTriangle} color={'red'} size="3x" />
                        </div>
                        <div className="message">
                            <div className="msg-text"><Markdown text={props.msgContent} /></div>
                            {props.errorMessage && <div className="msg-text"><Markdown text={localization.commonLoc.error} />: {props.errorMessage}</div>}
                        </div>
                    </div>
                </div>
                <div className="buttons-row">
                    <button className="dialog-button primary-style" onClick={() => props.onClose()}>
                        <Markdown text={props.closeBtnText || localization.commonLoc.close} />
                    </button>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-dialogs/editor-error.dialog.tsx